import React, { useEffect, useState } from "react";

import AddAppliance from "./AddAppliance";
import "./index.css";

const AddDevice = () => {
  const [animation, setAnimation] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setAnimation(true);
    }, 1000);
    return () => {
      clearTimeout(timer);
    };
  }, []);

  return (
    <div className={`add-appliance-view ${animation ? "active" : ""}`}>
      <AddAppliance />
    </div>
  );
};

export default AddDevice;
